





























































































































import { AxiosError } from 'axios'
import { Component, Mixins } from 'vue-property-decorator'
import { validationMixin } from 'vuelidate'
import { required, email, sameAs } from 'vuelidate/lib/validators'

import { postPaakayttaja } from '@/api/kayttajahallinta'
import ElsaButton from '@/components/button/button.vue'
import ElsaFormError from '@/components/form-error/form-error.vue'
import ElsaFormGroup from '@/components/form-group/form-group.vue'
import ElsaFormMultiselect from '@/components/multiselect/multiselect.vue'
import { KayttajahallintaNewKayttaja, ElsaError } from '@/types'
import { toastFail, toastSuccess } from '@/utils/toast'
import VastuuhenkilonTehtavat from '@/views/kayttajahallinta/vastuuhenkilon-tehtavat.vue'

@Component({
  components: {
    ElsaButton,
    ElsaFormGroup,
    ElsaFormError,
    ElsaFormMultiselect,
    VastuuhenkilonTehtavat
  },
  validations: {
    form: {
      etunimi: { required },
      sukunimi: { required },
      sahkoposti: {
        required,
        email
      },
      sahkopostiUudelleen: {
        required,
        email,
        sameAsSahkoposti: sameAs('sahkoposti')
      },
      eppn: {
        required
      }
    }
  }
})
export default class PaakayttajaForm extends Mixins(validationMixin) {
  form: KayttajahallintaNewKayttaja = {
    etunimi: null,
    sukunimi: null,
    sahkoposti: null,
    sahkopostiUudelleen: null,
    eppn: null
  }
  saving = false

  async onSubmit() {
    if (!this.validateForm()) {
      return
    }
    this.saving = true

    try {
      const kayttajaId = (
        await postPaakayttaja({
          ...this.form
        })
      ).data.kayttaja?.id
      toastSuccess(this, this.$t('paakayttaja-lisatty'))
      this.$emit('skipRouteExitConfirm', true)
      this.saving = false
      this.$router.push({
        name: 'paakayttaja',
        params: { kayttajaId: `${kayttajaId}` }
      })
    } catch (err) {
      const axiosError = err as AxiosError<ElsaError>
      const message = axiosError?.response?.data?.message
      toastFail(
        this,
        message
          ? `${this.$t('tietojen-tallennus-epaonnistui')}: ${this.$t(message)}`
          : this.$t('tietojen-tallennus-epaonnistui')
      )
      this.saving = false
    }
  }

  onCancel() {
    this.$router.push({
      name: 'kayttajahallinta'
    })
  }

  validateState(name: string) {
    const { $dirty, $error } = this.$v.form?.[name] as any
    return $dirty ? ($error ? false : null) : null
  }

  validateForm(): boolean {
    this.$v.form.$touch()
    return !this.$v.$anyError
  }
}
